import React, { useEffect } from "react";
import Header from "../Layout/Header";
import { makeStyles } from "@material-ui/core/styles";
import { Box, Container, Typography } from "@material-ui/core";
import Footer from "../Layout/Footer";
import { gpColors } from "../../constants/colors";
import CORRUGATE_BOXES from "../../Images/CORRUGATE_BOXES.png";
import CHIPBOARD_BOXES from "../../Images/CHIPBOARD_BOXES.png";
import {Helmet} from 'react-helmet'
const useStyles = makeStyles((theme) => ({
  container: {
    width: "100%",
    padding: "30px",
    position: "relative",
    marginTop: "75px",
    [theme.breakpoints.up("sm")]: {
      marginTop: "105px",
    },
  },
  productHeader: {
    fontWeight: 900,
    fontSize: "20px",
    height: "53px",
    background: "#36404b",
    margin: "0px",
    lineHeight: "58px",
    letterSpacing: "1px",
    textAlign: "center",
    color: "#fff",
    position: "relative",
    width: "260px",
    marginBottom: "30px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    "&:before": {
      content: "''",
      left: "-20px",
      borderStyle: "solid",
      borderWidth: "0 0 53px 20px",
      borderColor: `transparent transparent ${gpColors.logoBrown} transparent`,
      position: "absolute",
    },
    "&:after": {
      content: "''",
      right: "-20px",
      borderStyle: "solid",
      borderWidth: "53px 20px 0 0",
      borderColor: `${gpColors.logoBrown} transparent transparent transparent`,
      position: "absolute",
    },
  },
  productContent: {
    fontSize: "16px",
    lineHeight: 2,
    textAlign: "justify",
  },
  bulletHeadings: {
    fontWeight: 600,
  },
}));
const PackagingSolutions = () => {
  const classes = useStyles();
  useEffect(() => {
    console.log("rendered");
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  }, []);

  return (
    <>
     <Helmet>
        <meta charSet="utf-8" />
        {/* <title>My Title</title> */}
        <meta name="keywords" content="Automotive Filter Manufacturer in India" />
        <meta
          name="description"
          content="Explore our comprehensive packaging solutions designed to meet your diverse needs. From custom packaging design to sustainable materials, we deliver innovative packaging solutions tailored to your industry. Discover our commitment to quality, efficiency, and environmental responsibility. Find the perfect packaging solution for your products today."
        />
      </Helmet>
      <Header />
      <Container>
        <div className={classes.container}>
          <div>
            <div
              style={{
                textAlign: "center",
                display: "flex",
                justifyContent: "center",
              }}
            >
              <div className={classes.productHeader}>Packaging Solutions</div>
            </div>

            <div className={classes.productContent}>
              <p>
                At GuardPlus, we understand the importance of packaging in
                protecting and presenting your products effectively. Our
                comprehensive packaging solutions are designed to meet your
                unique needs, ensuring that your products are packaged securely,
                attractively, and sustainably. With our expertise and commitment
                to quality, we offer a range of packaging options that will
                elevate your brand and enhance your customer experience.
              </p>
              <p>
                <span className={classes.bulletHeadings}>
                  1. Custom Packaging Design:
                </span>
              </p>
              <p>
                We specialize in custom packaging design, tailored specifically
                to your product requirements and brand identity. Our experienced
                design team works closely with you to create packaging solutions
                that capture your brand essence, enhance product visibility, and
                maximize shelf appeal. From concept development to final
                production, we ensure that every detail is meticulously crafted
                to meet your expectations.
              </p>
              <p>
                <span className={classes.bulletHeadings}>
                  2. Diverse Packaging Materials:
                </span>
              </p>
              <p>
                We offer a wide variety of packaging materials to cater to
                different product types and industries. Whether you need
                corrugated boxes, or chipboard alternatives, we have the right
                materials to suit your packaging needs. Our materials are
                carefully selected for their durability, protection, and
                aesthetic appeal, ensuring that your products arrive in pristine
                condition and make a lasting impression.
              </p>
              <Box
                display="flex"
                justifyContent="center"
                marginTop={4}
                marginBottom={2}
              >
                <Typography variant="h6" component="h6">
                  <b>CORRUGATE BOXES</b>
                </Typography>
              </Box>
              <Box display="flex" flexWrap="wrap">
                <Box
                  sx={{
                    width: { xs: "100%", md: "70%", sm: "70%" },
                    textAlign: "justify",
                  }}
                >
                  We can provide quality corrugate boxes in size and shapes and
                  color as per customer requirement without any additional fees
                  for customization. We have three quality types available:
                  <ul>
                    <li>Single Wall</li>
                    <li>Double Wall</li>
                    <li>Triple Wall</li>
                  </ul>
                </Box>
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: {
                      xs: "center",
                      md: "flex-end",
                      sm: "center",
                    },
                    width: { xs: "auto", md: "30%", sm: "30%" },
                  }}
                >
                  <img
                    src={CORRUGATE_BOXES}
                    style={{ maxWidth: "80%", maxHeight: "300px" }}
                    alt="CORRUGATE BOXES"
                  />
                </Box>
              </Box>
              <Box
                display="flex"
                justifyContent="center"
                marginTop={4}
                marginBottom={2}
              >
                <Typography variant="h6" component="h6">
                  <b>CHIPBOARD BOXES</b>
                </Typography>
              </Box>
              <Box display="flex" flexWrap="wrap">
                <Box
                  sx={{
                    width: { xs: "100%", md: "70%", sm: "70%" },
                    textAlign: "justify",
                  }}
                >
                  We offer fully customize solutions for chipboard boxes. Our
                  chipboard boxes come with auto lock bottom making it efficient
                  and easy to use on production and packing lines. We provide
                  variety of options.
                  <ul>
                    <li>Brown Chipboard Boxes</li>
                    <li>White Chipboard Boxes</li>
                    <li>
                      Full Graphics with customize artwork Chipboard Boxes
                    </li>
                  </ul>
                </Box>
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: {
                      xs: "center",
                      md: "flex-end",
                      sm: "center",
                    },
                    width: { xs: "auto", md: "30%", sm: "30%" },
                  }}
                >
                  <img
                    src={CHIPBOARD_BOXES}
                    alt="CHIPBOARD_BOXES"
                    style={{ maxHeight: "300px", maxWidth: "80%" }}
                  />
                </Box>
              </Box>
              <p>
                <span className={classes.bulletHeadings}>
                  3. Innovative Packaging Solutions:
                </span>
              </p>
              <p>
                We stay at the forefront of packaging innovation to provide you
                with cutting-edge solutions. Our team continuously explores new
                technologies and trends to offer packaging options that enhance
                functionality, convenience, and sustainability. From smart
                packaging with interactive elements to unique opening and
                closing mechanisms, we strive to make your packaging stand out
                in the market.
              </p>
              <p>
                <span className={classes.bulletHeadings}>
                  4. Quality Assurance:
                </span>
              </p>
              <p>
                Quality is our top priority. We adhere to rigorous quality
                control measures throughout the packaging production process.
                From material selection and structural integrity to print
                quality and finishing, we ensure that every packaging solution
                meets the highest industry standards. Your satisfaction and the
                safety of your products are always our primary concerns.
              </p>
              <p>
                <span className={classes.bulletHeadings}>
                  5. Customer Support:
                </span>
              </p>
              <p>
                Our dedicated customer support team is ready to assist you at
                every step of the packaging process. Whether you have questions,
                need guidance, or require assistance with customization, our
                knowledgeable professionals are here to help. We believe in
                building long-term partnerships and providing exceptional
                service to meet your evolving packaging needs.
              </p>
            </div>
          </div>
        </div>
      </Container>
      <Footer />
    </>
  );
};
export default PackagingSolutions;
